import { SEND_CHART as SOCKET_SEND_CHART } from '../../events/DashboardToServer'

export const CHART_UPDATED = 'CHART_UPDATED'
export const SEND_CHART = 'SEND_CHART'

export const chart = (state = [], action) => {
    switch (action.type) {
        case CHART_UPDATED:
            return action.chart
        
        default:
            return state
    }
}

export const chartUpdated = (chart, match) => {
    return { type: CHART_UPDATED, chart, match }
}

export const sendChart = (socket) => {
    socket.emit(SOCKET_SEND_CHART)
    return { type: SEND_CHART }
}


// WEBPACK FOOTER //
// ./src/reducers/chart/index.js